module.exports = __webpack_public_path__ + "static/media/Proximus-Light.15e90298.woff";